import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const NUMBER_OF_DAILY_TRANSACTIONS_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.numberOfDailyTransactionsCount,
    label: "Daily Transactions",
    tooltip: CatalogMetricSlugs.number_of_daily_transactions_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.numberOfDailyTransactionsCount,
    width: 170,
    render: (item) => {
        const measure = getMeasureValue(
            item,
            "number_of_daily_transactions_count",
        );

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};
